var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgBitbucket = function SvgBitbucket(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 96 96",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2684ff",
    d: "M4.05 5.737A3.012 3.012 0 0 0 1.04 9.231l12.785 77.613a4.096 4.096 0 0 0 4.006 3.419h61.334a3.012 3.012 0 0 0 3.012-2.53L94.961 9.246a3.012 3.012 0 0 0-3.012-3.494L4.051 5.737Zm53.836 56.094H38.31l-5.301-27.693h29.62l-4.743 27.693Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bitbucket_svg__a)",
    d: "M90.818 34.1H62.575l-4.74 27.67h-19.56L15.176 89.186a4.078 4.078 0 0 0 2.633.993h61.301a3.01 3.01 0 0 0 3.01-2.528l8.697-53.552Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bitbucket_svg__a",
    x1: 8232.27,
    x2: 4969.73,
    y1: 809.013,
    y2: 5441.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBitbucket);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;